import React, { PropsWithChildren } from "react";
import { Grid } from "@material-ui/core";

export const CbTemplateLayoutLeft = (props: PropsWithChildren<any>) => (
  <Grid item xs={12} md={8}>
    {props.children}
  </Grid>
);
